import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=368a05c8&"
import script from "./Rating.vue?vue&type=script&lang=js&"
export * from "./Rating.vue?vue&type=script&lang=js&"
import style0 from "./Rating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports